import {
  ChangeDetectorRef,
  Component,
  Inject,
  OnDestroy,
  OnInit,
} from '@angular/core';

import { Camera } from '@capacitor/camera';
import { Capacitor } from '@capacitor/core';
import * as ExifReader from 'exifreader';
import {
  allowedImageFormats,
  compressImage,
  compressImageAndAddData,
  DIALOG_DATA,
  isLargeScreen,
} from '../../../../global.variable';
import { AppService } from '../../../app.service';
import { PagesService } from '../../../pages/pages/pages.service';
import { DeviceInfoService } from '../../services/device-info.service';
import { LoadingSpinnerService } from '../../services/loading-spinner.service';
import { SyncClockService } from '../../services/sync-clock.service';
import { ToasterService } from '../../services/toaster.service';
import { DialogRef } from '../modal-dialogue/modal-dialogue.ref';
import { ModalDialogueService } from '../modal-dialogue/modal-dialogue.service';
import { UploadTypeComponent } from '../upload-type/upload-type.component';
import { v4 as uuidv4 } from 'uuid';
@Component({
  selector: 'gtapp-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrl: './file-upload.component.scss',
  standalone: false,
})
export class FileUploadComponent implements OnInit, OnDestroy {
  showFrom: any;
  uploadType: string = 'live';
  fileType: string = 'image';

  fileUrl: any;
  actualUploadFile: any;
  fileData: any = [];
  fileExtension: string = '';

  btnLable: string = 'Save';
  newComment: any;

  isCameraOpen: boolean = false;
  apidataUpdation: boolean = true;
  handOverLogDraft: boolean = false;
  clientCount: number = 0;
  dialogeRef: any;

  groupUserCount = this.pageService.getGroupUserCount();

  largeView: Boolean = isLargeScreen;
  exifData: any;
  addTimeStamp: boolean = false;
  addressData: any;

  fileUploadedAtTime: any;

  miscSubjectParamSubscription: any;

  fileErrorMessage: any;
  constructor(
    protected camDialogRef: DialogRef,
    private pageService: PagesService,
    private dialogService: ModalDialogueService,
    @Inject(DIALOG_DATA) public dialogueData: any,
    private toasterService: ToasterService,
    private appService: AppService,
    private spinnerService: LoadingSpinnerService,
    private deviceInfoService: DeviceInfoService,
    private cdr: ChangeDetectorRef,
    private clockService: SyncClockService,
  ) {}

  ngOnInit(): void {
    this.showFrom = this.dialogueData.showFrom;

    this.newComment = null;

    this.selectDeviceUploadType();
    this.miscSubjectParamSubscription =
      this.pageService.miscSubjectParam.subscribe((value: any) => {
        this.apidataUpdation = value?.addPhotoClientCount?.apidataUpdation;
        this.clientCount = value?.addPhotoClientCount?.clientCount;
      });
  }

  //File submit to parent component
  onFileSubmit() {
    let image = {
      actualFileUpload: this.actualUploadFile,
      uploadType: this.uploadType,
      newComment: this.newComment,
      exifData: this.exifData,
      fileUrl: this.fileUrl,
      uploadedAt: this.fileUploadedAtTime,
      fileExtension: this.fileExtension,
    };

    this.camDialogRef.close(image);
  }

  close() {
    this.camDialogRef.close();
  }

  //Showing this button only with update client or job
  onSavePhoto() {
    let image = {
      actualFileUpload: this.actualUploadFile,
      newComment: this.newComment,
      uploadType: this.uploadType,
      handOverLogDraft: this.handOverLogDraft,
      exifData: this.exifData,
      uploadedAt: this.fileUploadedAtTime,
      fileExtension: this.fileExtension,
    };
    this.camDialogRef.close(image);
  }

  ngOnDestroy(): void {
    if (this.miscSubjectParamSubscription)
      this.miscSubjectParamSubscription?.unsubscribe();
  }
  getVideoMetadata(file: any) {
    return new Promise((resolve) => {
      const video = document.createElement('video');

      video.preload = 'metadata';
      video.src = URL.createObjectURL(file);

      video.onloadedmetadata = () => {
        const videoMetaData = {
          videoWidth: video.videoWidth,
          videoHeight: video.videoHeight,
        };

        URL.revokeObjectURL(video.src);

        resolve(videoMetaData);
      };

      video.onerror = () => {
        URL.revokeObjectURL(video.src);
        resolve(false);
      };
    });
  }
  async fileCheckError(uploadedFile: any) {
    const uploadedImageFileSize = uploadedFile?.size;
    var fileSizeInKB = uploadedImageFileSize / 1024; // Size in KB
    if (fileSizeInKB < 1) return { message: 'Unsupported file' };

    this.fileExtension = uploadedFile?.name?.split('.')?.pop() || '';

    if (fileSizeInKB > 50 * 1024) {
      // file should be less than 50MB
      let videoMetaData = { sizeInMb: Math.floor(fileSizeInKB / 1024) };
      if (['mp4', 'mov', 'webm', 'mkv'].includes(this.fileExtension)) {
        const videoCheck = await this.getVideoMetadata(uploadedFile);
        if (!videoCheck) return { message: 'Unsupported file' };
        videoMetaData = { ...videoMetaData, ...videoCheck };
      }
      return {
        videoMetaData: videoMetaData,
        message: `File size too large`,
      };
    }

    // if (
    //   this.uploadType !== 'live' &&
    //   this.fileType === 'image' &&
    //   ['mp4', 'mov', 'webm', 'mkv'].includes(this.fileExtension)
    // ) {
    //   //https://app.shortcut.com/sendem/story/9626/uploading-videos#activity-12381
    //   // removed toggle section
    //   this.fileType = 'video';
    // }

    const allowedFileFormats =
      this.fileType === 'image'
        ? allowedImageFormats
        : ['mp4', 'mov', 'webm', 'mkv'];

    if (!allowedFileFormats.includes(this.fileExtension?.toLowerCase()))
      return { message: 'Unsupported file format' };

    return false;
  }
  async handleImageCompressionAndOutput(file: any) {
    this.spinnerService.show('Compressing Photo');
    try {
      if (this.largeView) {
        this.spinnerService.show('Reading');
        try {
          this.exifData = await this.getExifData(file);
        } catch (error) {
          this.exifData = { gps: {} };
        }
      }
      if (this.addTimeStamp) {
        if (!this.addressData?.country_name) {
          this.spinnerService.show('Getting Location');
          this.addressData = await this.getReverseAddressFromGps();
        }
        this.fileUploadedAtTime = this.clockService.nowMs();

        this.actualUploadFile = await compressImageAndAddData(
          file,
          30000,
          2000,
          {
            updated_at: new Date(this.fileUploadedAtTime),
            ...this.addressData,
          },
        );
      } else {
        this.actualUploadFile = await compressImage(file);
      }

      var fileSizeInKB = this.actualUploadFile?.size / 1024; // Size in KB

      if (fileSizeInKB < 1) {
        throw new Error('Unsupported file');
      }
      this.fileExtension = 'avif';

      if (['scanCheckpoint'].includes(this.showFrom)) {
        this.spinnerService.hide();
        this.onFileSubmit();
      } else if (['supportQuery', 'credentialPhoto'].includes(this.showFrom)) {
        //Show image preview
        let reader = new FileReader();
        reader.onload = (event: any) => {
          this.fileUrl = event.target.result;
          this.spinnerService.hide();
          this.onFileSubmit();
        };
        this.spinnerService.show('Loading Image');
        reader.readAsDataURL(this.actualUploadFile);
      } else {
        //Show image preview
        let reader = new FileReader();
        reader.onload = (event: any) => {
          this.fileUrl = event.target.result;
          this.spinnerService.hide();
        };
        this.spinnerService.show('Loading Image');
        reader.readAsDataURL(this.actualUploadFile);
        this.isCameraOpen = false;
      }
    } catch (error) {
      const elementId = this.getElementId();
      const fileInputElement = document.getElementById(
        elementId,
      ) as HTMLInputElement;
      fileInputElement.value = '';
      this.fileUrl = null;
      this.actualUploadFile = null;
      this.spinnerService.hide();
      this.toasterService.setMessage({
        errorMessage: String(error),
        successMessage: '',
      });
      throw error;
    }
  }
  async handleVideoCompressionAndOutput(file: any) {
    this.spinnerService.show('Processing');
    try {
      if (this.largeView) {
        this.spinnerService.show('Reading');
        this.exifData = { gps: {} };
      }

      this.actualUploadFile = file;

      var fileSizeInKB = this.actualUploadFile?.size / 1024; // Size in KB

      if (fileSizeInKB < 1) {
        throw new Error('Unsupported file');
      }

      //Show image preview
      let reader = new FileReader();
      reader.onload = (event: any) => {
        this.fileUrl = event.target.result;

        this.spinnerService.hide();
      };
      this.spinnerService.show('Loading Video');
      reader.readAsDataURL(this.actualUploadFile);
      this.isCameraOpen = false;
    } catch (error) {
      const elementId = this.getElementId();
      const fileInputElement = document.getElementById(
        elementId,
      ) as HTMLInputElement;
      fileInputElement.value = '';
      this.fileUrl = null;
      this.actualUploadFile = null;
      this.spinnerService.hide();
      this.toasterService.setMessage({
        errorMessage: String(error),
        successMessage: '',
      });
      throw error;
    }
  }

  async handleFileInput(item: any) {
    const fileErrorMessage = await this.fileCheckError(item.files.item(0));
    if (fileErrorMessage) {
      this.fileErrorMessage = fileErrorMessage;
      this.toasterService.setMessage({
        errorMessage: this.fileErrorMessage?.message,
        successMessage: '',
      });
      return;
    }

    if (this.fileType === 'image') {
      this.handleImageCompressionAndOutput(item.files.item(0));
    } else {
      this.handleVideoCompressionAndOutput(item.files.item(0));
    }
  }
  getElementId() {
    if (this.fileType === 'image') {
      return this.uploadType === 'live'
        ? 'imageFileInputLive'
        : 'imageFileInput';
    } else {
      return this.uploadType === 'live'
        ? 'videoFileInputLive'
        : 'videoFileInput';
    }
  }
  async openCamera() {
    if (Capacitor.isNativePlatform()) {
      try {
        const image = await Camera.takePhoto({
          quality: 90,
          webUseInput: true,
          saveToGallery: false, // Stops the post-capture library prompt
        });

        const webPath: any = image.webPath;
        const base64Response = await fetch(webPath);
        const blobData = await base64Response.blob();

        const unifiedFileObject = new File(
          [blobData],
          `captured_image_${uuidv4()}.jpg`,
          {
            type: 'image/jpeg',
          },
        );
        const fileErrorMessage = await this.fileCheckError(unifiedFileObject);
        if (fileErrorMessage) {
          this.fileErrorMessage = fileErrorMessage;
          this.toasterService.setMessage({
            errorMessage: this.fileErrorMessage?.message,
            successMessage: '',
          });
          return;
        }

        if (this.fileType === 'image') {
          this.handleImageCompressionAndOutput(unifiedFileObject);
        } else {
          this.handleVideoCompressionAndOutput(unifiedFileObject);
        }
      } catch (error) {}
    } else {
      const elementId = this.getElementId();
      var button: any = document.getElementById(elementId);
      button.click();
    }
    setTimeout(() => {
      this.isCameraOpen = true;
    }, 100);
  }

  selectDeviceUploadType() {
    // check whther the device is desktop, then no need to show options just open the library
    this.fileErrorMessage = null;
    if (this.largeView) {
      this.uploadType = 'device';
      this.openCamera();
    } else if (this.showFrom === 'scanCheckpoint') {
      this.btnLable = 'Scan Checkpoint';
      this.uploadType = 'live';
      this.openCamera();
    }
    // else if (this.showFrom === 'credentialPhoto') {
    //   this.btnLable = 'Upload';
    //   this.uploadType = 'live';
    //   this.openCamera();
    // }
    else {
      this.dialogeRef = this.dialogService.open(UploadTypeComponent, {
        data: { showFrom: this.showFrom },
      });
      this.dialogeRef.afterClosed().subscribe((res: any) => {
        if (res?.value === false) {
          this.camDialogRef.close();
        } else {
          this.uploadType = res?.value;
          this.addTimeStamp = res?.timeStamp;
          this.fileType = res?.fileType || this.fileType;
          this.cdr.detectChanges();

          if (this.addTimeStamp) {
            // get gps and reversedecode it
            this.getReverseAddressFromGps().then(
              (address: any) => (this.addressData = address),
            );
          }

          this.openCamera();
        }
      });
    }
  }

  getExifData(file: File): Promise<any> {
    return new Promise(async (resolve, reject) => {
      try {
        const exifData = await ExifReader.load(file);

        const humanReadableData: any = {
          Make: exifData['Make']?.description,
          Model: exifData['Model']?.description,
          DateTime: exifData['DateTime']?.description,
        };

        const gpsData = this.getGpsData(exifData);
        if (gpsData) {
          humanReadableData['gps'] = gpsData;
        }

        resolve(humanReadableData);
      } catch (error) {
        throw error;
      }
    });
  }
  getGpsData(gpsData: any): any {
    let latVal = gpsData['GPSLatitude']?.description;
    let directions: any = {};
    if (latVal) {
      const latDirection = (
        gpsData['GPSLatitudeRef']?.value?.[0] ||
        gpsData['GPSLatitudeRef']?.description?.[0]
      )?.toUpperCase();
      if (latDirection) {
        directions['latDirection'] = latDirection;
        if (latDirection === 'S' || latDirection === 'W') {
          latVal = latVal * -1;
        }
      }
    }

    let lonVal = gpsData['GPSLongitude']?.description;
    if (lonVal) {
      const lonDirection = (
        gpsData['GPSLongitudeRef']?.value?.[0] ||
        gpsData['GPSLongitudeRef']?.description?.[0]
      )?.toUpperCase();
      if (lonDirection) {
        directions['lonDirection'] = lonDirection;
        if (lonDirection === 'S' || lonDirection === 'W') {
          lonVal = lonVal * -1;
        }
      }
    }
    if (latVal && lonVal)
      return {
        lat: Number(latVal?.toFixed(6)),
        lon: Number(lonVal?.toFixed(6)),
        ...directions,
      };
    return null;
  }
  async getReverseAddressFromGps() {
    return new Promise(async (resolve) => {
      const reverseLookupGps: any =
        await this.deviceInfoService.getGpsCoordinates();
      this.appService
        .getReverseLocation(reverseLookupGps?.lat, reverseLookupGps?.lon)
        .subscribe((response: any) => {
          let addressStreet = response?.address?.Address.split(' ');
          let streetName = [
            ...addressStreet?.filter(
              (item: any) => item != response?.address?.AddNum,
            ),
          ].join(' ');
          resolve({
            address1: response?.address?.AddNum || '',
            address2: streetName,
            address3: null,
            city_name: response?.address?.Neighborhood
              ? response?.address?.Neighborhood
              : response?.address?.City,
            state_code:
              response?.address?.RegionAbbr || response?.address?.Region,
            longitude: reverseLookupGps?.lon,
            latitude: reverseLookupGps?.lat,
            postcode: response?.address?.Postal,
            state_name:
              response?.address?.Region || response?.address?.RegionAbbr,
            country_name: response?.address?.CntryName,
          });
        });
    });
  }
}
